import { ParametricSelector } from '@reduxjs/toolkit';

export const getIdFromProps: ParametricSelector<unknown, { id: number }, number> = (_, props) => props.id;
